export default __webpack_public_path__ + "static/media/chaise-rounded-rectangle-1-break.0edab52f.webp";